var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Page"},[_c('div',{staticClass:"Page-Content",staticStyle:{"overflow":"hidden"}},[_c('iframe',{staticStyle:{"width":"calc(100% - 55px)","height":"100%","padding":"0","margin":"0","margin-right":"55px"},attrs:{"src":"./siteplan.html","frameborder":"0"}})])])
}]

export { render, staticRenderFns }